/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import Image from "~components/atoms/image/image";
import Table from "~components/atoms/table/table";
import BlogFullWidth from "~components/molecules/blog_full_width/blog_full_width";
import CaptionImage from "~components/molecules/caption_image/caption_image";
import CaptionVideo from "~components/molecules/caption_video/caption_video";
import ImageGrid from "~components/molecules/image_grid/image_grid";
import ImageLink from "~components/molecules/image_link/image_link";
import QuoteBlock from "~components/molecules/quote/quote_block/quote_block";
import RichTextAlertCard from "~components/molecules/rich_text_alert_card/rich_text_alert_card";
import TextLink from "~components/molecules/text_link/text_link";
import TickList from "~components/molecules/tick_list/tick_list";
import Video from "~components/molecules/video/video/video";
import DescriptionList from "~components/organisms/description_list/description_list";
import SourceCodeWindow from "~components/organisms/source_code_window/source_code_window";
import SourceCode from "~components/organisms/source_code_window/sub_components/source_code/source_code";
import { blokMarginStyle } from "../rich_text.module.scss";

// eslint-disable-next-line import/prefer-default-export
export const RichTextBlokResolvers = {
  [`blogFullWidth`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <BlogFullWidth {...props} />
      </div>
    );
  },
  [`captionImage`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <CaptionImage {...props} />
      </div>
    );
  },
  [`captionVideo`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <CaptionVideo {...props} />
      </div>
    );
  },
  [`descriptionList`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <DescriptionList {...props} />
      </div>
    );
  },
  [`image`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <Image {...props} />
      </div>
    );
  },
  [`imageGrid`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <ImageGrid {...props} />
      </div>
    );
  },
  [`imageLink`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <ImageLink {...props} />
      </div>
    );
  },
  [`quote`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <QuoteBlock {...props} hasBlockQuoteStyle />
      </div>
    );
  },
  [`richTextAlertCard`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <RichTextAlertCard {...props} />
      </div>
    );
  },
  [`sourceCode`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <SourceCode {...props} />
      </div>
    );
  },
  [`sourceCodeWindow`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <SourceCodeWindow {...props} />
      </div>
    );
  },
  [`table`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <Table {...props} />
      </div>
    );
  },
  [`textLink`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <TextLink {...props} />
      </div>
    );
  },
  [`tickList`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <TickList {...props} />
      </div>
    );
  },
  [`video`]: (props) => {
    return (
      <div className={blokMarginStyle}>
        <Video {...props} />
      </div>
    );
  },
};
